import api from "~/services/api";

export const postPaymentListServices = (body) => {
	return api.post(`${process.env.REACT_APP_URL_API_PAYOUT}payment/list`, body);
};
export default {
	postPaymentListServices,
};
